import React, {useCallback, useEffect, useMemo, useState} from "react";
import Cookies from "js-cookie";
import {LocalUser} from "../../typing";
import UserContext, {UserContextType} from "./context/UserContext";
// import useMemoizedFn from "@firefly/fly-kda/dist/hook/useMemoizedFn";
import {useQueryClient} from "react-query";
import useMemoizedFn from "../../hook/useMemoizedFn";

const login = (window as any).$.login;
const module = (window as any).NiuxLoginModule.getInstance();
module.init({
    isNeedVipInfo: false
});
export interface UserContextProviderProps {
    children: React.ReactNode;
}
function UserContextProvider(props: UserContextProviderProps) {
    const {
        children
    } = props;

    const [current, setCurrent] = useState<LocalUser | null>(null)
    const fetch = useCallback<() => LocalUser | null>(() => {
        const userid = Cookies.get('userid');
        const nickname = Cookies.get('usernick');
        const username = Cookies.get('usrname');
        console.log(userid, nickname, username);
        (window as any)._Cookies = Cookies;
        const _current = userid ? {
            uid: userid!,
            nickname: nickname!,
            username: username!,
        } : null;
        setCurrent(_current);
        return _current
    }, []);
    console.log("current", current);

    const queryClient = useQueryClient();
    useEffect(() => {
        queryClient.invalidateQueries({
            queryKey: ['viewer']
        })
    }, [current?.uid, queryClient]);

    const authenticate = useCallback(() => {
        console.log("show login", module)
        module.show("login", {
            loginOkCallBack: () => {
                fetch();
            }
        });
    }, [])
    const logout = useCallback(() => {
        login.logout();

    }, [])

    useEffect(() => {
        fetch();
        login.registerAfterOperationFun(function() {
            fetch();
        });
    }, [fetch]);

    const authenticated = useMemoizedFn(() => {
        if (!current) {
            authenticate();
            return Promise.reject('unauthenticated');
        }
        return Promise.resolve();
    })
    const ContextValue = useMemo<UserContextType>(() => {
        return {
            current: current,
            fetch: fetch,
            authenticate,
            logout,
            authenticated,
        }
    }, [fetch, current, authenticate, logout])
    return <UserContext.Provider value={ContextValue}>
        {children}
    </UserContext.Provider>
}

export default UserContextProvider;